// The Bubbles display's time line (#141, #385): the centred "Today 2:41 PM" above a message. One rule for every client;
// the cases are shared/cases/bubble-stamp.json, which the Swift and Kotlin ports run too.

/** A time line goes above a message when this long has passed since the one before. */
export const STAMP_MS = 15 * 60_000;

/** The calendar day of a time, in the viewer's zone: two times are on the same day when their keys are equal. */
export type DayOf = (ts: number) => string;

const localDay: DayOf = (ts) => new Date(ts).toDateString();

/**
 * Whether the message sent at `ts` gets a time line above it. `prevTs` is the `ts` of the message just before it in the
 * list, whatever it is (a system line counts, a message from another author counts); null for the first one held. It is
 * the sent time: an edit does not change it. True for the first message, on a new day, and when `STAMP_MS` or more has
 * passed. A message that sorts before the one above it (a clock that ran back) gets a line only on a new day.
 * `dayOf` is the viewer's zone, local time by default.
 */
export function bubbleStamp(prevTs: number | null | undefined, ts: number, dayOf: DayOf = localDay): boolean {
  if (prevTs == null) return true;
  return dayOf(prevTs) !== dayOf(ts) || ts - prevTs >= STAMP_MS;
}
